import { ErrorHandler, Injectable } from '@angular/core';
import { AuditService } from '@core/services/audit.service';
import { Router } from '@angular/router';
import { UserService } from '@core/services/user.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private audit: AuditService,
    private router: Router,
    private userService: UserService,
  ) {}

  handleError(error: any): void {
    this.audit.logError({
      applicationName: 'LRP Proveedores Frontend',
      exception: error?.message || error.toString(),
      frontendRoute: this.router?.url || '',
      userAgent: navigator?.userAgent || '',
      browser: this.getBrowser(),
      statusCode: error?.status || 0,
      userId: this.userService.userName() || '',
    });
  }

  private getBrowser(): string {
    const ua = navigator.userAgent;
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari')) return 'Safari';
    return 'Unknown';
  }
}
